<template>
    <div style="padding: 10px 0;">
            <div class="ListArrBox" @click="LookInfo">
              <div class="ArrTitle">
                <div  v-html="Item['Title']"></div>
                <span>{{Item['ShowTime'].substr(0,10)}}</span>
              </div>
              <div class="ArrTxt"  v-html="Item['Describe']">   
                  <!-- {{Item['Describe']}} -->
              </div>
              <!-- v-if="$route.path!='$route.path'" -->
               <!-- <div class="ArrTxt"  v-html="Item['Describe']" v-if="$route.path=='$route.path'"></div> -->
            </div>
    </div>
</template>
<script>
export default {
    props:{
        Item:{
            type:Object
        }
    },
    data(){
        return{
            url:'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
        }
    },
    methods:{
        LookInfo(){
            this.$emit('LookInfo',{ids:this.Item.ID,url:this.Item.Url})
        }
    }
}
</script>
<style lang="scss" scoped>
      .ListArrBox{
        width:100%;
        padding: 20px 0;
        border-bottom: 1px solid rgba(238, 238, 238, .7);
        padding-top: 0;
        &:hover > .ArrTitle>div{
           color:rgba(65, 96, 206, 1);
           cursor: pointer;
        }
        .ArrTitle{
          display: inline-flex;
          width:100%;
          color: #333333;
          div{
            flex:1;
            font-size: 16px;
            font-weight: 400;
            text-align: left;
            &::before{
              content: '⦁';
              font-size: 16px;
              padding-right:5px ;
            }
          }
          span{
            width:150px;
            text-align: right;
          }
        }
        .ArrTxt{
          margin-top:10px ;
          text-align: left;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
</style>